export default __webpack_public_path__ + "img/openstreetmap-cd3823a0417294a6e55b226d2f00fb40.jpg";